import _defineProperty from '@babel/runtime/helpers/defineProperty';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Merge multiple objects and their within style objects
// Temporary fix until the issue is resolved in react-aria: https://github.com/adobe/react-spectrum/issues/8314#issuecomment-2916684139

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var mergeStyleProps = function mergeStyleProps() {
  for (var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++) {
    objects[_key] = arguments[_key];
  }
  return objects.reduce(function (base, obj) {
    return _objectSpread(_objectSpread(_objectSpread({}, base), obj), {}, {
      style: _objectSpread(_objectSpread({}, (base === null || base === void 0 ? void 0 : base.style) || {}), (obj === null || obj === void 0 ? void 0 : obj.style) || {})
    });
  }, {});
};

export { mergeStyleProps };
//# sourceMappingURL=mergeStyleProps.js.map
